import { action } from 'satcheljs';
import type { CalendarComposeInitializationConfig } from 'owa-calendar-helpers-types/lib/CalendarComposeInitializationConfig';
import type { CustomData } from 'owa-analytics-types';
import type UnifiedTelemetryContext from 'owa-calendar-unified-telemetry-utils/lib/types/UnifiedTelemetryContext';

export interface LaunchCalendarFullComposeActionMessage {
    config: CalendarComposeInitializationConfig;
    freezeDryId: string | undefined;
    customStartTime: number | undefined;
    targetWindow: Window | undefined;
    otherData: CustomData | undefined;
    deskComposeAllowed: boolean | undefined; // Temporary parameter while this flight is being rolled out : msplaces-enable-desk-booking-popout WI https://outlookweb.visualstudio.com/Time%20and%20Places/_backlogs/backlog/Team%20Rhythm/Epics
    openInNewWindow: boolean | undefined;
    unifiedEventTelemetryContext?: UnifiedTelemetryContext;
}
export const launchCalendarFullCompose: (
    config: CalendarComposeInitializationConfig,
    freezeDryId?: string,
    customStartTime?: number,
    targetWindow?: Window,
    otherData?: CustomData,
    deskComposeAllowed?: boolean,
    openInNewWindow?: boolean,
    unifiedEventTelemetryContext?: UnifiedTelemetryContext
) => LaunchCalendarFullComposeActionMessage = action(
    'launchCalendarFullCompose',
    (
        config: CalendarComposeInitializationConfig,
        freezeDryId?: string,
        customStartTime?: number,
        targetWindow?: Window,
        otherData?: CustomData,
        deskComposeAllowed = true,
        openInNewWindow?: boolean,
        unifiedEventTelemetryContext?: UnifiedTelemetryContext
    ): LaunchCalendarFullComposeActionMessage => ({
        config,
        freezeDryId,
        customStartTime,
        targetWindow,
        otherData,
        deskComposeAllowed,
        openInNewWindow,
        unifiedEventTelemetryContext,
    })
);
